export class UserStatsData {
    constructor(userID, gameID, category, type, changeInValue, metadata = undefined){
        this.userID = userID;
        this.gameID = gameID;
        this.category = category;
        this.type = type;
        this.changeInValue = changeInValue;
        this.metadata = metadata;
    }
}
